import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7d137d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = {
  class: "d-flex align-items-center",
  style: {"margin-bottom":"8px"}
}
const _hoisted_4 = { class: "rating" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-flag ms-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-flag-fill text-danger" })
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" For more information about the tenant review, call the property manager. ")
const _hoisted_7 = {
  class: "address details d-flex",
  style: {"margin-bottom":"8px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-map-marker-alt icon" }, null, -1))
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "dates details d-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt icon" }, null, -1))
const _hoisted_12 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StreetViewImage = _resolveComponent("StreetViewImage")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ selected: _ctx.isCurrent(_ctx.review) }, "view-tenant-review-history-item d-flex align-items-center"]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewReport && _ctx.viewReport(...args)))
  }, [
    _createVNode(_component_StreetViewImage, {
      onView: _ctx.viewStreetView,
      "image-src": _ctx.review.map_street_src
    }, null, 8, ["onView", "image-src"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass(["fa fa-star me-1 star", {
              'text-warning': _ctx.hasRate(_ctx.review.average_rating),
              'text-grey': !_ctx.hasRate(_ctx.review.average_rating),
            }])
          }, null, 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getRate(_ctx.review.average_rating)), 1),
          (_ctx.review.is_flagged === 'yes')
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 0,
                placement: "top-start",
                width: 250,
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getAddress(_ctx.review)), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getDates(_ctx.review)), 1)
        ])
      ])
    ])
  ], 2))
}